import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {DomainValueMapDTO} from '../models/DomainValueMapDTO';

@Injectable({
  providedIn: 'root'
})
export class DomainValueMapService {
  private readonly baseUrl = environment.baseIgnUrl + '/domain-value-map';

  constructor(private readonly httpClient: HttpClient) {
  }

  getMessageDirections(): Observable<DomainValueMapDTO[]> {
    return this.httpClient.get<DomainValueMapDTO[]>(`${this.baseUrl}/message-direction`);
  }
}
